import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Row, Col, FormControl, Popover, OverlayTrigger, Glyphicon } from 'react-bootstrap'

import AddMetadataValue from './AddMetadataValue'
import EditMetadataValue from './EditMetadataValue'

import { addMetadataValue, editMetadataValue, deleteMetadataValue } from '../../projects/reducers/manageProjects'

import { addProposalMetadataValue, editProposalMetadataValue, deleteProposalMetadataValue } from '../../proposals/reducers/manageProposals'

class ManageMetadataValues extends Component {

  state = {
    selectedClient: '',
    selectedModel: 'Project',
    selectedMetadata: '',
    selectedMetadataForEdit: '',
    selectedMetadataValue: '',
  }

  resetSelectedMetadataAfterSave = () => {
    // This function runs after a metadata value is edited or deleted to properly update state and make sure that the edited value string of a metadata value is properly updated in displays and deleted metadata values are removed from displays
    let currentMetadata, currentMetadataValues

    if (this.state.selectedModel === "Project") {
      currentMetadata = 'projectMetadata'
      currentMetadataValues = 'metadata_values'
    } else if (this.state.selectedModel === "Proposal") {
      currentMetadata = 'proposalMetadata'
      currentMetadataValues = 'proposal_metadata_values'
    }

    // find the selectedMetadata in the props to make sure that we have its updated metadata_values
    const selectedMetadata = this.props[currentMetadata].find(meta => meta.id === this.state.selectedMetadata.id)

    let { selectedMetadataForEdit, selectedMetadataValue } = this.state

    // if selectedMetadata is the same as selectedMetadataForEdit in state, reset selectedMetadataForEdit to reflect any updated or deleted metadata_values
    if (selectedMetadataForEdit && selectedMetadataForEdit.id && selectedMetadataForEdit.id === selectedMetadata.id) {
      selectedMetadataForEdit = selectedMetadata
    }

    // Check if there is a metadata_value selected for editing/deletion. If it has been deleted by the user, remove it from the the selectedMetadataForEdit's metadata_values and deselect that deleted metadata_value in state
    if (selectedMetadataValue && selectedMetadataForEdit) {
      let foundValue = selectedMetadataForEdit[currentMetadataValues].find(value => value.id === selectedMetadataValue.id)

      if (foundValue) {
        selectedMetadataValue = foundValue
      } else {
        selectedMetadataValue = ''
      }
    }

    this.setState({ selectedMetadata, selectedMetadataForEdit, selectedMetadataValue })
  }


  handleChangeClient = (e) => {
    const selectedClient = this.props.clients.find(client => client.id === e.target.value)

    let selectedMetadata = ''
    if (selectedClient && this.state.selectedModel === 'Project') {
      selectedMetadata = this.props.projectMetadata.filter(meta => meta.client === selectedClient.url)[0]
    }

    if (selectedClient && selectedClient.subdomain === 'genesis') {
      this.setState({ selectedClient, selectedMetadata })
    } else if (selectedClient) {
      this.setState({ selectedClient, selectedMetadata, selectedModel: 'Project',  })
    } else {
      this.setState({ selectedClient: '' })
    }
  }

  handleSelectModel = (e) => {
    const selectedModel = e.target.value

    if (selectedModel === 'Project') {
      this.setState({
        selectedModel,
        selectedMetadata: this.props.projectMetadata.filter(meta => meta.client === this.state.selectedClient.url)[0],
        selectedMetadataForEdit: '',
        selectedMetadataValue: '',
      })
    } else if (selectedModel === 'Proposal') {
      this.setState({
        selectedModel,
        selectedMetadata: this.props.proposalMetadata[0],
        selectedMetadataForEdit: '',
        selectedMetadataValue: '',
      })
    }
  }

  handleSwitchSelectedMetadata = (e, key) => {
    const id = e.target.value

    let currentMetadata

    if (this.state.selectedModel === "Project") {
      currentMetadata = 'projectMetadata'
    } else if (this.state.selectedModel === "Proposal") {
      currentMetadata = 'proposalMetadata'
    }

    const selectedMetadata = this.props[currentMetadata].find(meta => meta.id === id)

    this.setState({ [key]: selectedMetadata })
  }


  handleSelectMetadataValue = (event) => {
    const id = event.target.value

    let valuesFieldName
    if (this.state.selectedModel === "Project") {
      valuesFieldName = 'metadata_values'
    } else if (this.state.selectedModel === "Proposal") {
      valuesFieldName = 'proposal_metadata_values'
    }

    if (id && valuesFieldName) {
      const selectedMetadataValue = this.state.selectedMetadataForEdit[valuesFieldName].find(value => {
        return value.id === id
      })

      this.setState({ selectedMetadataValue })
    } else {
      this.setState({ selectedMetadataValue: '' })
    }
  }

  getMetadataValueProps = () => {
    // Most state here is handled on this parent component even when it might seem simpler to move the state onto the AddMetadataValue or EditMetadataValue components because of the differences in key naming (metadata_values/proposal_metadata_values) in the selectedMetadata/selectedMetadataForEdit state elements (depending on whether the user is working with proposal or project metadata). Given that the selectedModel is housed on this parent component, keeping the rest of the state here prevents crashes if the user switches between projects and proposals
    const { selectedClient, selectedModel, selectedMetadata, selectedMetadataForEdit, selectedMetadataValue } = this.state

    const basicProps = {
      selectedModel,
      selectedClient,
      selectedMetadata,
      selectedMetadataForEdit,
      selectedMetadataValue,
      handleSwitchSelectedMetadata: this.handleSwitchSelectedMetadata,
      handleSelectMetadataValue: this.handleSelectMetadataValue,
      resetSelectedMetadataAfterSave: this.resetSelectedMetadataAfterSave,
    }

    if (this.state.selectedModel === 'Project') {
      return {
        ...basicProps,
        metadata: this.props.projectMetadata.filter(meta => meta.client === selectedClient.url),
        valuesFieldName: 'metadata_values',
        route: 'metadata-values',
        addMetadataValue: this.props.addProjectMetadataValue,
        editMetadataValue: this.props.editProjectMetadataValue,
        deleteMetadataValue: this.props.deleteProjectMetadataValue,
      }
    } else if (this.state.selectedModel === 'Proposal') {
      return {
        ...basicProps,
        metadata: this.props.proposalMetadata,
        valuesFieldName: 'proposal_metadata_values',
        route: 'proposal-metadata-values',
        addMetadataValue: this.props.addProposalMetadataValue,
        editMetadataValue: this.props.editProposalMetadataValue,
        deleteMetadataValue: this.props.deleteProposalMetadataValue,
      }
    }
  }

  render () {
    const { selectedClient, selectedModel } = this.state

    const { clients } = this.props

    const metadataValueInfoPopover = (
      <Popover id='metadata-value-info-popover' title="Note">
        <p>
          Metadata values for dates, numbers, text, and users will not appear here.
        </p>

        <p>
          Users cannot be deleted but can be added in the Add Users panel below.
        </p>

        <p>
          Dates, numbers, and text will function like normal date and number inputs and do not need to be   managed.
        </p>

      </Popover>
    )

    const clientOptions = clients.map(client => {
      if (client.managed_by_genesis === true) {
        return (
          <option key={client.id} value={client.id}>
            {client.name} {client.short_code}
          </option>
        )
      } else {
        return null
      }
    })

    return (
      <div id="ManageMetadataValues">
        <Row>
          <Col xsHidden smHidden mdHidden lg={3}></Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <h5>Select Client</h5>
              <FormControl
                componentClass="select"
                name="selectedClient"
                onChange={this.handleChangeClient}
                selected={selectedClient}
              >
                <option value=""> - </option>
                {clientOptions}
              </FormControl>
              <br/>
            {this.state.selectedClient ?
              <Fragment>
                <h5>Select Model</h5>
                <FormControl
                  componentClass="select"
                  name="selectedModel"
                  onChange={this.handleSelectModel}
                  value={selectedModel}
                >
                  <option value="Project">Projects</option>
                  {selectedClient && selectedClient.subdomain === 'genesis' ?
                    <option value="Proposal">Proposals</option>
                    :
                    null
                  }
                </FormControl>
              </Fragment>
              :
              null
            }
          </Col>
          <Col xsHidden smHidden mdHidden lg={3}></Col>
        </Row>
        <br/>
        {selectedClient ?
          <div>
            <div>
              <h4 style={{display: 'inline-block', marginRight: '10px'}}>
                Add {this.state.selectedModel} Metadata Values
              </h4>
              <OverlayTrigger
                style={{display: 'inline-block'}}
                trigger={["hover", "focus"]}
                placement="right"
                overlay={metadataValueInfoPopover}
              >
                <Glyphicon glyph='info-sign' />
              </OverlayTrigger>
              <AddMetadataValue {...this.getMetadataValueProps()} />
            </div>
            <hr/>
            <div>
              <h4 style={{display: 'inline-block', marginRight: '10px'}}>
                Edit {this.state.selectedModel} Metadata Values
              </h4>
              <OverlayTrigger
                style={{display: 'inline-block'}}
                trigger={["hover", "focus"]}
                placement="right"
                overlay={metadataValueInfoPopover}
              >
                <Glyphicon glyph='info-sign' />
              </OverlayTrigger>
              <EditMetadataValue {...this.getMetadataValueProps()} />
            </div>
          </div>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    projectMetadata: state.manageProjects.metadata.filter(meta => {
      return meta.type.toLowerCase() === 'selectable options'
    }),
    proposalMetadata: state.manageProposals.proposalMetadata.filter(meta => {
      return meta.type.toLowerCase() === 'selectable options'
    }),
    clients: state.manageLogin.clients,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProjectMetadataValue: (value) => dispatch(addMetadataValue(value)),
    editProjectMetadataValue: (value) => dispatch(editMetadataValue(value)),
    deleteProjectMetadataValue: (value) => dispatch(deleteMetadataValue(value)),
    addProposalMetadataValue: (value) => dispatch(addProposalMetadataValue(value)),
    editProposalMetadataValue: (value) => dispatch(editProposalMetadataValue(value)),
    deleteProposalMetadataValue: (value) => dispatch(deleteProposalMetadataValue(value)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageMetadataValues)



// WEBPACK FOOTER //
// ./src/routes/manager/components/ManageMetadataValues.js